import { useState, useEffect } from 'react';
import { InstallGuideModal } from './InstallGuideModal';

function isIosSafari() {
  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  return isIOS && isSafari;
}

function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as any).standalone === true;
}

export function InstallPrompt() {
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (isStandalone()) return;

    // Only show on mobile (max 1024px)
    if (window.innerWidth >= 1024) return;

    const dismissed = localStorage.getItem('pwa-install-dismissed');
    if (dismissed && new Date(dismissed) > new Date()) return;

    // Android/Chrome: wait for beforeinstallprompt
    const handler = (e: Event) => {
      e.preventDefault();
      setShowBanner(true);
    };
    window.addEventListener('beforeinstallprompt', handler);

    // iOS Safari: show banner manually after a short delay
    if (isIosSafari()) {
      setTimeout(() => setShowBanner(true), 3000);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleDismiss = () => {
    setShowBanner(false);
    const exp = new Date();
    exp.setDate(exp.getDate() + 14);
    localStorage.setItem('pwa-install-dismissed', exp.toISOString());
  };

  if (!showBanner && !showModal) return null;

  return (
    <>
      {/* Compact banner above bottom nav */}
      <div className="fixed bottom-16 left-0 right-0 z-40 lg:bottom-4 lg:left-auto lg:right-4 lg:w-80">
        <div className="mx-3 lg:mx-0 bg-primary-green text-white rounded-2xl shadow-lg px-4 py-3 flex items-center gap-3">
          <img src="/icon-192x192.png" alt="" className="w-9 h-9 rounded-xl flex-shrink-0" style={{ background: 'none' }} />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold leading-tight">Installer Gribklan Social</p>
            <p className="text-xs text-white/70 leading-tight">Tilføj til hjemmeskærm</p>
          </div>
          <button
            onClick={() => { setShowBanner(false); setShowModal(true); }}
            className="flex-shrink-0 bg-white text-primary-green text-xs font-bold px-3 py-1.5 rounded-lg hover:bg-gray-100 transition-colors"
          >
            Se guide
          </button>
          <button onClick={handleDismiss} className="flex-shrink-0 text-white/60 hover:text-white p-0.5">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      {showModal && <InstallGuideModal onClose={() => setShowModal(false)} />}
    </>
  );
}
